module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "header text-left"
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "",
      "type": "inverse",
      "variant": "black"
    }
  }, [_c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": _vm.getHomeUrl()
    }
  }, [(_vm.authUser && _vm.authUser.company && _vm.authUser.company.picture) ? [(_vm.authUser && _vm.authUser.company && _vm.authUser.company.picture) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.authUser.company.picture,
      "alt": ""
    }
  }) : _vm._e()] : [(_vm.company && _vm.company.picture) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.company.picture,
      "alt": ""
    }
  }) : _vm._e()], _vm._v(" "), _c('span', [_vm._v(" EZ GO Console")])], 2), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('div', {
    staticClass: "user-dropdown"
  }, [(_vm.authUser) ? _c('b-nav-item-dropdown', {
    attrs: {
      "right": ""
    }
  }, [(_vm.authUser) ? _c('template', {
    slot: "button-content"
  }, [_c('span', {
    staticClass: "username",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.authUser.first_name) + " " + _vm._s(_vm.authUser.last_name))]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "username"
  }, [(_vm.authUser && _vm.authUser.company) ? [_vm._v("\n                " + _vm._s(_vm.authUser.company.name) + "\n              ")] : (_vm.company && _vm.company.name) ? [_vm._v("\n                " + _vm._s(_vm.company.name) + "\n              ")] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.userLogout($event)
      }
    }
  }, [_vm._v("logout")])], 2) : _vm._e()], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-449bf882","hasScoped":false}!./src/components/header/header.component.html
// module id = 541
// module chunks = 1